import React from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { Formik, Form} from "formik";
import * as Yup from "yup";
import { useSuspendUserMutation } from "../../../../../redux/apiSlice";
import TextInput from "../../../Common/components/text-input";

export const SuspendUserModal = ({ showSuspendSocialUserModal, onHide, details }) => {
  const [
    suspendUser, // This is the mutation trigger
    {
      isLoading: isUpdating
    }, // This is the destructured mutation result
  ] = useSuspendUserMutation();

  /* Submit Function */
  const onSubmit = (values) => {
    suspendUser({
      profileId: details?.profileId,
      ...values
    })
      .unwrap()
      .then(() => {
        cogoToast.success("Created 'Suspend User' Action Successfully");
        onHide();
      });
  };

  return (
    <Modal
      show={showSuspendSocialUserModal}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop={isUpdating ? "static" : true}
      keyboard={!isUpdating}
    >
      <Formik
        initialValues={{
          suspensionReason: "",
          suspensionDurationInDays: "",
        }}
        validationSchema={
          Yup.object({
            suspensionReason: Yup.string().required("required"),
            suspensionDurationInDays: Yup.number().required("required"),
          })
        }
        onSubmit={(values) => onSubmit(values)}
      >
        <Form>
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              Suspend User
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
            </button>
          </Modal.Header>

          <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
            <FormLayout.Row>
              <TextInput
                label="Reason"
                name="suspensionReason"
              />
            </FormLayout.Row>
            <FormLayout.Row>
              <TextInput
                label="Duration(Days)"
                type="number"
                name="suspensionDurationInDays"
              />
            </FormLayout.Row>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              onClick={onHide}
              disabled={isUpdating}
              className="btn btn-light btn-elevate px-4"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isUpdating}
              className="btn btn-primary btn-elevate px-4 ml-4"
            >
              Suspend
            </button>
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
};

export default SuspendUserModal;
